export default {
  computed: {
    gdSetting() {
      return window.gd_settings;
    },
    isFrance() {
      return this.gdSetting.organisation_id === 12;
    },
  },
};
